import React, { Fragment, useEffect, useState } from "react";
import MainContainer from "../../components/container/MainContainer";
import { Link, useLocation, useParams } from "react-router-dom";
import { getProject, unsetSelectedProject } from "../../features/projectsSlice";
import { useDispatch, useSelector } from "react-redux";
import ProjectApproval from "./ProjectApproval";
import {
  getProjectStatuses,
  unsetProjectStatuses,
} from "../../features/projectStatusesSlice";
import ProjectTasks from "./ProjectTasks";
import Loading from "../../components/loading/Loading";
import ItemContainer from "../../components/form/ItemContainer";
import FinanceArrayContainer from "../../components/container/FinanceArrayContainer";
import { compareBudget, formatCurrency, sumArray } from "../../util";
import { openModal } from "../../features/modalSLice";
import Modal from "../../components/modal/Modal";
import AddTaskNarative from "../tasks/AddTaskNarative";
import AddTaskExpense from "../tasks/AddTaskExpense";
import { setSelectedTask } from "../../features/tasksSlice";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";
import BudgetTableContainer from "../../components/text/BudgetTableContainer";
import CategoryBudgetTableContainer from "../../components/text/CategoryBudgetTableContainer";
import TextContainer from "../../components/text/TextContainer";
// import TaskTab from "./TaskTab";

const ProjectDetails = () => {
  const [activeTab, setActiveTab] = useState("general");
  const [showDropdown, setShowDropdown] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const project = useSelector((state) => state.projects.selected);
  const projectsLoad = useSelector((state) => state.projects.load.getProject);
  const modalContent = useSelector((state) => state.modal.content);

  const projectStatusesLoad = useSelector(
    (state) => state.projectStatuses.load.getProjectStatuses
  );
  const { id } = useParams();

  useEffect(() => {
    dispatch(getProject(id));
    dispatch(getProjectStatuses());
    return () => {
      dispatch(unsetSelectedProject());
      dispatch(unsetProjectStatuses());
    };
  }, []);

  const tabs = [
    { key: "general", label: "General Info" },
    { key: "financial", label: "Financial Info" },
    // { key: "partner", label: "Local Partner Info" },
    { key: "additional", label: "Additional Info" },
    { key: "tasks", label: "Tasks" },
    // { key: "approval", label: "Approval" },
  ];
  // .filter((item) => {
  //   if (project.status && project.status.toLowerCase() === "upcoming") {
  //     return item.key !== "tasks";
  //   }
  //   if (project.status && project.status.toLowerCase() === "active") {
  //     return item.key !== "approval";
  //   }
  //   if (project.status && project.status.toLowerCase() === "canceled") {
  //     return item.key !== "approval" && item.key !== "tasks";
  //   } else {
  //     return item.key !== "approval" && item.key !== "tasks";
  //   }
  // });

  //Handle Add Narative
  const handleAddNarativeModalOpen = () => {
    dispatch(
      setSelectedTask(
        project.milestones
          .find((i) => i.number === 3)
          .tasks.find((i) => i.number === 19)
      )
    );
    dispatch(openModal(<AddTaskNarative />));
  };

  //Handle Add Expense
  const handleAddExpenseModalOpen = () => {
    dispatch(
      setSelectedTask(
        project.milestones
          .find((i) => i.number === 3)
          .tasks.find((i) => i.number === 19)
      )
    );
    dispatch(openModal(<AddTaskExpense />));
  };
  //Handle Add Bulk Expense

  if (!project.id || projectsLoad === loadStatus.loading) {
    return <Loading />;
  }

  if (projectsLoad === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <MainContainer>
      <Modal>{modalContent}</Modal>
      <div className="w-full mx-auto lg:p-10">
        <div className="bg-content shadow-md rounded-lg p-1 sm:p-4">
          <h4 className=" mb-4 text-text-1/80">{project.name}</h4>

          <div className="mb-4 border-b border-bkg2">
            <div className="sm:hidden relative">
              <button
                onClick={() => setShowDropdown(!showDropdown)}
                className="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm border-primary text-text-1"
              >
                {tabs.find((tab) => tab.key === activeTab)?.label}
              </button>
              {showDropdown && (
                <div className="absolute z-10 bg-content border rounded shadow-lg w-full">
                  {tabs.map((tab) => (
                    <button
                      key={tab.key}
                      onClick={() => {
                        setActiveTab(tab.key);
                        setShowDropdown(false);
                      }}
                      className={`block w-full text-left py-2 px-4 text-sm ${
                        activeTab === tab.key
                          ? "bg-primary text-text-1/75"
                          : "text-text-1/75 hover:bg-bkg2"
                      }`}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>
              )}
            </div>
            <nav className="hidden sm:flex space-x-8">
              {tabs.map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm text-text-1/80 ${
                    activeTab === tab.key
                      ? "border-primary text-primary"
                      : "border-transparent text-text-1 hover:text-text-1/50 hover:border-text-1"
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </nav>
          </div>
          {project.id && (
            <div>
              {activeTab === "general" && (
                <div>
                  <div className="flex justify-start gap-3 items-center">
                    {project.id &&
                      project.status.toLowerCase() === "active" && (
                        <Fragment>
                          <button
                            className="add-rss-btn my-4"
                            onClick={handleAddNarativeModalOpen}
                          >
                            Add Narrative
                          </button>
                          <button
                            className="add-rss-btn my-4"
                            onClick={handleAddExpenseModalOpen}
                          >
                            Add Expense
                          </button>
                        </Fragment>
                      )}
                  </div>
                  <div className="pb-4"></div>

                  <ItemContainer
                    content={project.description}
                    label="Description"
                    isHTML
                  />
                  <ItemContainer
                    content={project.community}
                    label="Community"
                  />
                </div>
              )}

              {activeTab === "financial" && (
                <div>
                  <div className="flex items-center justify-between">
                    <div>
                      <ItemContainer
                        label="Currency : "
                        content={project.currency?.name}
                      />
                    </div>
                  </div>
                  {/* Budget */}
                  <div className="w-full overflow-x-auto">
                    <BudgetTableContainer
                      label="Budget"
                      content={project.budget || []}
                    />
                  </div>

                  {/* Budget by Category*/}
                  <div className="w-full overflow-x-auto">
                    <CategoryBudgetTableContainer
                      label="Budget by Category"
                      content={project.catBudget || []}
                    />
                  </div>
                </div>
              )}

              {activeTab === "additional" && (
                <div>
                  <TextContainer
                    isHTML
                    label="Justification"
                    content={project.justification}
                  />
                  <TextContainer
                    isHTML
                    label="Monitoring Supervision"
                    content={project.monitoring_supervision}
                  />
                  <TextContainer
                    isHTML
                    label="Sustainability Plan"
                    content={project.sustainability_plan}
                  />
                </div>
              )}
            </div>
          )}

          {activeTab === "tasks" && <ProjectTasks />}
        </div>
      </div>
    </MainContainer>
  );
};

export default ProjectDetails;
